import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const HHScore = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  color: #79D9D9;
  font-weight: 700;
  font-size: 1.2em;
  position: absolute;
  bottom: 10px;
  width: 250px;
  right: 20px;
  align-items: flex-end;
  height: 45px;

  svg {
    color: rgb(187, 187, 187);
    font-size: 0.55em;
    margin-left: 5px;
    position: relative;
    bottom: 5px;
    cursor: pointer;

    &:hover {
      color: #402680;
    }
  }

  ${mediaMaxWidth.phone} {
    position: relative;
    right: 0;
    left: 0;
    bottom: 0;
    margin: 0 auto;
    justify-content: center;
  }
`;

export const Score = styled.span`
  margin: 0 5px 0 7px;
  font-size: 1.8em;
  font-family: sans-serif;
  position: relative;
  top: 6px;
`;

export const OutOf = styled.span`
  color: #666;
  font-weight: 700;
  font-size: 0.6em;
  position: relative;
  bottom: 3px;
`;

export const Tooltip = styled.div``;
